import * as React from "react";
import styled from "styled-components";
const Container = styled.div`
  display: flex;

  > div:first-child > div {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  > div:last-child > div {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  > div:not(:first-child) > div {
    border-left: 0;
  }

  > div:not(:first-child, :last-child) > div {
    border-radius: 0;
  }
`;
const SelectGroup = ({ children, className = void 0 }) => /* @__PURE__ */ React.createElement(Container, { className }, children);
export default SelectGroup;
